import React, { Component } from "react";

import * as s from "./LoadingRow.module.scss";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  width?: number;
  height?: number;
  style?: any;
  fixed?: boolean;
}

export class LoadingRow extends Component<Props> {
  render() {
    const { width, height, style, fixed } = this.props;
    const delay = Math.floor(Math.random() * -1000);
    const randWidth = fixed ? width : Math.floor(Math.random() * (width / 2)) + width / 2;
    const afterStyle = { animationDelay: `${delay}ms` };
    const wrapperStyle = { width: `${randWidth}px`, height: `${height}px`, ...style };
    return (
      <span className={s.placeholder} style={wrapperStyle}>
        <span className={s.after} style={afterStyle} />
      </span>
    );
  }
}
